import { Cpu, Factory, Wind, Pill, ShoppingBag, ShoppingCart, DollarSign, Wrench, HardHat, Rocket, Building2, Briefcase } from "lucide-react";

// Single source of truth — must match INDUSTRIES in backend/server.py
export const INDUSTRIES = [
  { name: "IT & Technology", icon: Cpu },
  { name: "Manufacturing", icon: Factory },
  { name: "HVAC & MEP", icon: Wind },
  { name: "Pharma", icon: Pill },
  { name: "FMCG", icon: ShoppingBag },
  { name: "E-commerce", icon: ShoppingCart },
  { name: "Finance", icon: DollarSign },
  { name: "Engineering", icon: Wrench },
  { name: "Construction", icon: HardHat },
  { name: "Startups", icon: Rocket },
  { name: "SMEs", icon: Building2 },
  { name: "Executive Search", icon: Briefcase },
];

export const INDUSTRY_NAMES = INDUSTRIES.map(i => i.name);

export const JOB_STATUS = {
  active: { l: "Active", cls: "bg-emerald-100 text-emerald-700" },
  on_hold: { l: "On Hold", cls: "bg-amber-100 text-amber-700" },
  closed: { l: "Closed", cls: "bg-slate-200 text-slate-600" },
};

export const CANDIDATE_SOURCES = [
  { v: "walk_in", l: "Walk-in" },
  { v: "whatsapp", l: "WhatsApp" },
  { v: "referral", l: "Referral" },
  { v: "job_portal", l: "Job Portal" },
  { v: "linkedin", l: "LinkedIn" },
  { v: "manual", l: "Other / Manual" },
];

export const SOURCE_LABELS = {
  registered: "Website Signup", cv_submission: "CV Submission",
  ...Object.fromEntries(CANDIDATE_SOURCES.map(s => [s.v, s.l])),
};
